import { useState, useCallback } from 'react';
import { Box, Grid, Heading, Bones } from '@simplywallst/ui-core';
import { DividendQualityForecastBarChart as BarChart } from './DividendQualityForecastBarChart';
import { DividendQualityForecastTooltip as ToolTip } from './DividendQualityForecastTooltip';
import { DividendQualityForecastTable as Table } from './DividendQualityForecastTable';
import type { Period } from '../../types/portfolioDividend';
import { INITIAL_PERIOD } from '../../constants/portfolioDividend';
import { Sentry } from '@/components/Sentry';
import { DividendDefaultError } from '../DividendDefaultError';
import { Suspense } from 'react';

const TOOLTIP_HEIGHT = 92;
const BAR_CHART_HEIGHT = 292;
const TABLE_HEIGHT = 430;

export const DividendQualityForecast = () => {
  const [selectedPeriod, setSelectedPeriod] = useState<Period>(INITIAL_PERIOD);

  const onColumnSelected = useCallback((key: Period) => {
    setSelectedPeriod(key);
  }, []);

  return (
    <Box padding="x1" paddingMd="x3" backgroundColor="noir" borderRadiusLg="x1">
      <Grid templateColumns="100%" templateColumnsLg="1fr 1fr" gap="24px">
        <div>
          <Box padding="x1" paddingMd="x0">
            <Heading as="h3" typography="xLargeStrong" color="textSolid">
              Dividend Quality & Forecast
            </Heading>
          </Box>
          <Sentry
            sentryCapture={{
              team: 'dingoes',
            }}
            customCopy={
              <Box paddingTop="x1" paddingTopMd="x2">
                <DividendDefaultError
                  height={TOOLTIP_HEIGHT + BAR_CHART_HEIGHT}
                />
              </Box>
            }
            globalDisabled
            isShownLogo={false}
            isShownHeading={false}
          >
            <Box paddingTop="x1" paddingTopMd="x2">
              <Suspense
                fallback={
                  <Grid templateRows={`${TOOLTIP_HEIGHT}px`}>
                    <Bones minHeight="100%" />
                  </Grid>
                }
              >
                <ToolTip selectedPeriod={selectedPeriod} />
              </Suspense>
            </Box>
            <Suspense
              fallback={
                <Grid templateRows={`${BAR_CHART_HEIGHT}px`}>
                  <Bones minHeight="100%" />
                </Grid>
              }
            >
              <BarChart onColumnSelected={onColumnSelected} />
            </Suspense>
          </Sentry>
        </div>
        <div>
          <Sentry
            sentryCapture={{
              team: 'dingoes',
            }}
            customCopy={<DividendDefaultError height={TABLE_HEIGHT} />}
            globalDisabled
            isShownLogo={false}
            isShownHeading={false}
          >
            <Suspense
              fallback={
                <Grid templateRows={`${TABLE_HEIGHT}px`}>
                  <Bones minHeight="100%" />
                </Grid>
              }
            >
              <Table selectedPeriod={selectedPeriod} />
            </Suspense>
          </Sentry>
        </div>
      </Grid>
    </Box>
  );
};
